import React from 'react';

import ProductionBomShowView from '@components/shared/production_boms/ProductionBomShowView';
import { useLoaderData } from 'react-router-dom';

export default function AdminProductionBomShow() {
  const productionBom = useLoaderData();

  return (
    <ProductionBomShowView
      productionBom={productionBom}
      role="admin"
    />
  );
}
